import jquery from 'jquery';

import EFOcats_logic from '../efocats_logic.js';

/**
 * データ送信機能
 */
export default class EFOcats_submit extends EFOcats_logic {
  /**
   * コンストラクタ
   */
  constructor() {
    super();
    this.analy_time_access = new Date();

    // 送信データ
    this.form_data = {};

    // 分析データ
    this.analy_data = {
      type: '',
      status: '',
      time: '',
      labeldata: [],
    };

    this.submitbtn_query = ".submit_ input[type='submit']";
  }

  /**
   * 初期化
   */
  initialize() {
    this.form_data.post = {};
    this.form_data.analytics = {};
    this.form_data.ID = efocats.account.id;
    this.form_data.formID = efocats.account.form_id;

    this.meta();
    this.$('input[type="hidden"]').each((index, element) => {
      if (jquery(element).closest('.hidden-area').length <= 0) {
        this.form_data[jquery(element).attr('name')] = jquery(element).val();
      }
    });

    // 項目作成
    this.data_label_first();

    // タイマー開始
    efocats.setInterval(this.countup, 1000);

    // 新規・再訪の確認
    this.visited();
  }

  /**
   * 時間をカウントする
   * @param {*} count
   */
  countup() {
    const num = efocats.submit.target();

    if (num <= 0) {
      return;
    }

    efocats.submit.analy_data.labeldata[num - 1].time += 1;
  }

  /**
   * ユーザーエージェント
   * @returns {*} ユーザーエージェント
   */
  meta() {
    const ua = navigator.userAgent.toLowerCase();
    let device = 'Other';

    // デバイス
    if (ua.indexOf('iphone') > 0 || (ua.indexOf('android') > 0 && ua.indexOf('mobile') > 0)) {
      device = 'SP';
    } else if (ua.indexOf('ipad') > 0 || ua.indexOf('android') > 0) {
      device = 'Tablet';
    } else if (ua.indexOf('windows nt') > 0 || ua.indexOf('mac os') > 0) {
      device = 'PC';
    }

    this.form_data.device = device;
  }

  /**
   * 項目作成
   */
  data_label_first() {
    this.$('.qa').each((index, element) => {
      const label = {};

      // 複数name修正（）
      label.title = jquery(element).find('.cat-txt').text();

      const inputs = jquery(element).find('input,textarea,select');

      label.name = '';

      for (let inputIndex = 0; inputIndex < inputs.length; inputIndex++) {
        const input = inputs.eq(inputIndex);
        if (input.attr('name')) {
          label.name = input.attr('name');
          break;
        }
      }

      label.error = [];
      label.status = this.data_label_first_status(inputs);
      label.time = 0;
      this.analy_data.labeldata.push(label);
    });
  }

  /**
   * 項目作成（ステータス）
   * @param {*} inputs
   */
  data_label_first_status(inputs) {
    let comp = 0;

    for (let index = 0; index < inputs.length; index++) {
      const input = inputs.eq(index);
      const type = input.attr('type');
      const name = input.attr('name');

      if (type === 'radio' || type === 'checkbox') {
        if (input.parents('.qa').find(`input[name="${name}"]:checked`).length > 0) {
          comp++;
        }
      } else if (input.val()) {
        comp++;
      }
    }

    // ページ内全ての入力欄に値が設定されている場合は入力完了扱いとする
    if (comp >= inputs.length) {
      return 'input_cmp';
    }
    return 'No_input';
  }

  /**
   * 新規か再訪問か
   */
  visited() {
    const $ = require('jquery');
    require('jquery.cookie');
    const cookie_visit = $.cookie(`${this.form_data.formID + this.form_data.ID}visit`);

    if (cookie_visit === 'return') {
      this.analy_data.type = 'return';
    } else {
      this.analy_data.type = 'new';
    }
    $.cookie(`${this.form_data.formID + this.form_data.ID}visit`, 'return', {
      expires: 31,
    });
  }

  /**
   * データ送信処理
   * @param  btn 送信ボタン
   */
  data_submit(btn) {
    let submit_style = false;

    if (btn) {
      submit_style = true;
      // 送信前のチェック
      if (!this.check_submitdata(btn)) {
        return;
      }
    }

    // 送信データ作成
    this.create_submitdata(submit_style);

    // 送信
    this.send_submitdata();
  }

  /**
   * 送信前のチェック
   * @param  btn 送信ボタン
   * @returns trueなら送信OK
   */
  check_submitdata(btn) {
    if (btn.parents) {
      return true;
    }

    const submitSection = btn.parents('section');
    if (submitSection.hasClass('qa') && !submitSection.hasClass('go-flag') && submitSection.find('.container').hasClass('required')) {
      return false;
    }

    return true;
  }

  /**
   * 送信データ作成
   */
  create_submitdata(submit_style) {
    this.$('.qa .inner').each((index, element) => {
      // 案件ごとの加工処理
      if (this.custom_submitdata(element)) {
        // 入力欄ごとの処理
        this.create_input_submitdata(jquery(element));
      }
    });

    this.submit_style_make(submit_style);
  }

  /**
   * 入力欄ごとの処理
   * @param {*} parentsElem
   */
  create_input_submitdata(parentsElem) {
    parentsElem.find('input,select,textarea').each((index2, inputelem) => {
      const formName = jquery(inputelem).attr('name');

      // この入力欄の処理をするか判断
      if (!this.check_input_submitdata(formName, inputelem)) {
        return;
      }

      // 一問一答の処理
      this.create_answer(formName, inputelem);
    });
  }

  /**
   * この入力欄の処理をするか判断
   * @param {*} formName
   * @param {*} inputelem
   */
  check_input_submitdata(formName, inputelem) {
    if (this.form_data.post[formName]) {
      return false;
    }

    return true;
  }

  /**
   * 一問一答の処理
   * @param {*} formName
   * @param {*} inputelem
   */
  create_answer(formName, inputelem) {
    const formType = jquery(inputelem).attr('type');

    if (formType === 'checkbox') {
      this.create_answer_checkbox(formName, inputelem);
    } else if (formType === 'radio') {
      this.create_answer_radio(formName, inputelem);
    } else {
      this.create_answer_other(formName, inputelem);
    }
  }

  /**
   * 一問一答の処理（チェックボックスとラジオ以外）
   * @param {*} formName
   */
  create_answer_other(formName, inputelem) {
    jquery(`[name="${formName}"]`).val(this.$(`[name="${formName}"]`).val());
  }

  /**
   * 一問一答の処理（ラジオ）
   * @param {*} formName
   */
  create_answer_radio(formName, inputelem) {
    jquery(`input[name="${formName}"][value="${this.$(`input[name="${formName}"][type="radio"]:checked`).val()}"]`).prop('checked', true);
  }

  /**
   * 一問一答の処理（チェックボックス）
   * @param {*} formName
   * @param {*} inputelem
   */
  create_answer_checkbox(formName, inputelem) {
    this.$(`input[name="${formName}"][type="checkbox"]`).each(() => {
      jquery(`input[name="${formName}"][value="${jquery(inputelem).val()}"]`).prop('checked', jquery(inputelem).prop('checked'));
    });
  }

  /**
   * 案件ごとの送信データ加工処理
   * @param {} element
   * @returns trueを返した場合、直後に入力欄ごとの処理を実行する、falseなら実行しない
   */
  custom_submitdata(element) {
    // 子クラスで実装（電話番号の分割処理など）
    // このメソッドで事足りるような場合はfalseを返して入力欄ごとの処理をスキップする
    return true;
  }

  /**
   * 送信データ送信
   */
  send_submitdata() {
    // ページ離脱のアラートをOFFにする
    jquery(window).off('.attention');

    this.form_data.post = '';

    if (navigator.sendBeacon) {
      const data = new FormData();

      data.append('post', this.form_data.post);
      data.append('analytics', this.form_data.analytics);
      data.append('device', this.form_data.device);
      data.append('ID', this.form_data.ID);
      data.append('formID', this.form_data.formID);

      console.log('sendBeacon');
      const res = navigator.sendBeacon('https://formcats.com/accept/accept.php', data);

      if (res) {
        this.success_submitdata();
      } else {
        this.fail_submitdata();
      }
    } else {
      const formdata = new FormData();
      formdata.append('post', this.form_data.post);
      formdata.append('analytics', this.form_data.analytics);
      formdata.append('device', this.form_data.device);
      formdata.append('ID', this.form_data.ID);
      formdata.append('formID', this.form_data.formID);
      jquery
        .ajax({
          url: 'https://formcats.com/accept/accept.php',
          type: 'post',
          dataType: 'json',
          data: formdata,
          contentType: false,
          processData: false,
        })
        .done((data, textStatus, jqXHR) => this.success_submitdata(data, textStatus, jqXHR))
        .fail((jqXHR, textStatus, errorThrown) => this.fail_submitdata(jqXHR, textStatus, errorThrown));
    }
  }

  /**
   * 送信成功時の処理
   */
  success_submitdata(a, b, c) {
    this.$('.efo-cat-main').css('display', 'none');

    // スクロール対策用のレイヤーも非表示
    jquery('#cat-dummy-layer').hide();

    // 離脱時の分析送信イベントを削除
    jquery(window).off('beforeunload.attention');

    const $ = require('jquery');
    require('jquery.cookie');
    $.cookie('submit', 'success', {
      expires: 31,
    });

    // 送信ボタンクリック
    const btn = $(this.submitbtn_query);
    btn.click();
  }

  /**
   * 送信失敗時の処理
   */
  fail_submitdata(a, b, c) {
    console.log(a, b, c);
  }

  /**
   * 送信データ作成
   * @param {*} submit_style
   */
  submit_style_make(submit_style) {
    const target_num = this.target();

    if (submit_style === true) {
      this.status_all(true);
    } else if (submit_style === false) {
      this.status_all(false);
      if (target_num > 0) {
        this.analy_data.labeldata[target_num - 1].status = 'leave';
      }
    }

    this.label_time_set(this.analy_data.labeldata);
    this.time_all();

    // analy_dataから「hidden」の項目を削除
    let delete_hidden_num = 0;
    this.$('.qa').each((index, element) => {
      if (jquery(element).hasClass('hidden')) {
        this.analy_data.labeldata.splice(index - delete_hidden_num, 1);
        delete_hidden_num += 1;
      }
    });

    // フォームデータと分析データを合体
    this.form_data.analytics = this.analy_data;

    // jsonデータ化
    this.form_data.analytics = JSON.stringify(this.form_data.analytics);
  }

  /**
   * 分析対象取得
   * @returns 分析対象
   */
  target() {
    let qa = this.$('.qa.action').index();
    if (this.$('.startPage').length <= 0) {
      qa += 1;
    }
    return qa;
  }

  /**
   * ステータス（全体）
   * @param {*} submit_style 入力を完了したかどうか(true=入力完了)
   */
  status_all(submit_style) {
    let no_input;
    let status = '';

    if (
      !this.$('.qa').find('input[type="radio"]:checked') &&
      !this.$('.qa').find('input[type="checkbox"]:checked') &&
      this.$('.qa').find('select').val() === '' &&
      this.$('.qa').find('input[type="text"],input[type="tel"],input[type="url"],input[type="email"]').val() === ''
    ) {
      no_input = true;
    }

    if (submit_style === true) {
      status = 'input_cmp';
    } else if (no_input === true) {
      status = 'No_input_leave';
    } else {
      status = 'input_mid_leave';
    }

    this.analy_data.status = status;
  }

  /**
   * 回答ごとの処理時間セット
   * @param {*} time_obj
   */
  label_time_set(time_obj) {
    Object.keys(time_obj).forEach(key => {
      const {time} = time_obj[key];
      const time_stamp = this.make_timestamp(time);
      this.analy_data.labeldata[key].time = time_stamp;
    });
  }

  /**
   * 全体の処理時間セット
   */
  time_all() {
    const analy_time_leave = new Date();
    const time = Math.floor((analy_time_leave.getTime() - this.analy_time_access.getTime()) / 1000);
    const time_stamp = this.make_timestamp(time);
    this.analy_data.time = time_stamp;
  }

  /**
   * タイムスタンプを作る
   * @param {*} time_obj 秒
   * @returns タイムスタンプ
   */
  make_timestamp(time_obj) {
    let hour = parseInt(time_obj / 3600, 10);
    let min = parseInt((time_obj / 60) % 60, 10);
    let sec = time_obj % 60;

    if (hour < 10) {
      hour = `0${hour}`;
    }
    if (min < 10) {
      min = `0${min}`;
    }
    if (sec < 10) {
      sec = `0${sec}`;
    }
    const time_stamp = `${hour}:${min}:${sec}`;

    return time_stamp;
  }

  /**
   * ステータス（個別）
   */
  status_individual(obj) {
    let status;
    const target = obj.parents('.qa');
    let val = true;

    // 必須項目取得
    const required_checks = target.find('.check-flag.required:visible');

    let checks;

    if (required_checks.length > 0) {
      checks = required_checks;
    } else {
      checks = target.find('.check-flag:visible');
    }

    for (let index = 0; index < checks.length; index++) {
      const check = checks.eq(index);

      // 入力欄取得
      const inputs = check.find('input,select,textarea');

      for (let index2 = 0; index2 < inputs.length; index2++) {
        const input = inputs.eq(index2);
        const type = input.attr('type');
        const name = input.attr('name');

        // 必須項目で値が入ってないものがあればNo_input
        if (type === 'radio' || type === 'checkbox') {
          if (check.find(`input[name="${name}"]:checked`).length === 0) {
            val = false;
            break;
          }
        } else if (!input.val()) {
          val = false;
          break;
        }
      }

      if (!val) {
        break;
      }
    }

    if (val) {
      status = 'input_cmp';
    } else {
      status = 'No_input';
    }

    const index = this.$('.qa').index(target);
    this.analy_data.labeldata[index].status = status;
  }

  /**
   * 分析エラー
   * @param {*}
   */
  error(status_data, checkData) {
    const target_num = this.$('.qa').index(checkData.parents('.qa'));

    if (status_data.status === 'error') {
      // 一つのセクションに複数の質問タイトルがある場合にエラーメッセージの前にタイトルを付加
      let multi_text;
      if (this.$('.qa').eq(target_num).find('.inner').find('.cat-txt-design').length > 1) {
        multi_text = checkData.parents('.box').find('.cat-txt-design').text();
        status_data.message = `${multi_text}:${status_data.message}`;
      }

      // 複数タイトルの場合
      const erro_num = this.analy_data.labeldata[target_num].error.push();

      const ja_text = this.errorMessage(status_data, checkData);

      // カウント
      const error = this.analy_data.labeldata[target_num].error.find(item => item.title === ja_text);

      if (error) {
        error.count += 1;
        return;
      }

      if (!this.analy_data.labeldata[target_num].error[erro_num]) {
        this.analy_data.labeldata[target_num].error[erro_num] = {
          title: '',
          count: '',
        };

        this.analy_data.labeldata[target_num].error[erro_num].title = ja_text;
        this.analy_data.labeldata[target_num].error[erro_num].count = 1;
      }
    }
  }

  /**
   * エラーメッセージを取得する
   * @param {*} status_data
   * @param {*} checkData
   */
  errorMessage(status_data, checkData) {
    return status_data.message;
  }
}
